import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CLIENT_SERVICES, LANGUAGES } from "@/types/staffing/serviceRequest";
import { cn } from "@/lib/utils";
import { SectionHeader, FieldRow, FieldLabel, ErrorMsg } from "./FormPrimitives";

interface StaffingDetailsSectionProps {
  clientService: string;
  onClientServiceChange: (val: string) => void;
  language: string;
  onLanguageChange: (val: string) => void;
  clientServiceError?: string;
  languageError?: string;
  disabled: boolean;
}

export function StaffingDetailsSection({
  clientService,
  onClientServiceChange,
  language,
  onLanguageChange,
  clientServiceError,
  languageError,
  disabled,
}: StaffingDetailsSectionProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-4 shadow-sm">
      <SectionHeader step={3} label="Staffing Details" />

      <FieldRow>
        <FieldLabel htmlFor="client-service" required>
          Client Services
        </FieldLabel>
        <Select value={clientService} onValueChange={onClientServiceChange} disabled={disabled}>
          <SelectTrigger
            id="client-service"
            className={cn(clientServiceError && "border-destructive")}
          >
            <SelectValue placeholder="Select a service role…" />
          </SelectTrigger>
          <SelectContent>
            {CLIENT_SERVICES.map((cs) => (
              <SelectItem key={cs} value={cs}>
                {cs}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <ErrorMsg msg={clientServiceError} />
      </FieldRow>

      <FieldRow>
        <FieldLabel htmlFor="language" required>
          Primary Language Spoken at Home
        </FieldLabel>
        <Select value={language} onValueChange={onLanguageChange} disabled={disabled}>
          <SelectTrigger
            id="language"
            className={cn(languageError && "border-destructive")}
          >
            <SelectValue placeholder="Select a language…" />
          </SelectTrigger>
          <SelectContent>
            {LANGUAGES.map((lang) => (
              <SelectItem key={lang} value={lang}>
                {lang}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <ErrorMsg msg={languageError} />
      </FieldRow>

      {/* <div className="flex items-start gap-2.5 rounded-md border border-border bg-muted/30 p-3">
        <Checkbox
          id="need-priority"
          checked={needPriority}
          onCheckedChange={(checked) => setNeedPriority(!!checked)}
          disabled={disabled}
          className="mt-0.5"
        />
        <Label
          htmlFor="need-priority"
          className="text-sm leading-relaxed cursor-pointer font-normal"
        >
          This case is currently being supported by the{" "}
          <span className="font-semibold">crisis committee</span> and/or has
          crisis management strategies within the plan.
        </Label>
      </div> */}
    </div>
  );
}
